import React from "react";
import { Centered, SplitPanel } from "../../CardsStyled";
import CardCore from "../../CardCore";
import StatusIcon from "../../../Icons/StatusIcon";
import { useTranslate } from "hooks/translation-hooks";

export const extraActionRequiredAction = "extra_action_required_card-displayed";

export const ExtraActionsRequired = ({ isCurrent }) => {
  const t = useTranslate();

  return (
    <SplitPanel>
      <Centered>
        <StatusIcon status="DROPOUT" />
      </Centered>
      <CardCore
        title={t("extra_actions_required_card-title")}
        additionalDescription={`${t("extra_actions_required_card-text_1")} ${t(
          "extra_actions_required_card-text_2"
        )} `}
      />
    </SplitPanel>
  );
};

export default ExtraActionsRequired;
